import React, { useState, useContext, useEffect, } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import DeckContext from '../../../store/DeckContext.jsx';
import DrillDownMap8 from './DrillDownMap8.jsx';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Button } from '@mui/material';
import { banner_hero_languages } from '../../../assets/img/index.js';




export const CylgSearchPage = ({ regions, countries, languages, }) => {

    const navigate = useNavigate();
    const [searchMode, setSearchMode] = React.useState('country');
    const [options, setOptions] = useState([]);
    const [vkCtry, setVkCtry] = useState([]);
    const [vkLang, setVkLang] = useState([]);
    const [toPage, setToPage] = useState('cy_search_page');

    const [searchValue, setSearchValue] = useState('');
    const [uid, setUid] = useState('');

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCountryName, setSelectedCountryName] = useState(null);

    const handleCountrySelect = (countryCode) => {
        setSelectedCountry(countryCode);
        setUid(countryCode);
        for (var i = 0; i < countries.length; i++) {
            if (countries[i].country_iso2 === countryCode) {
                setSelectedCountryName(countries[i].country_name_fr);
            }
        }
        // Ici, tu peux passer le code pays à ExpressionSelector ou autre composant
        console.log('Pays sélectionné :', countryCode);
    };

    const ctx = useContext(DeckContext);

    // Liste des options (soit Pays soit Langues)
    useEffect(() => {
        const vk = [];
        {
            countries && countries.sort((a, b) => a.country_name_fr > b.country_name_fr ? 1 : -1).map(
                (el, index,) => {
                    let item = {};
                    item["id"] = index;
                    item["label"] = el.country_name_fr;
                    item["country_uid"] = el.country_uid;
                    item["label_en"] = el.country_name_en;
                    item["country_iso2"] = el.country_iso2;
                    item["country_name_fr"] = el.country_name_fr;
                    vk.push(item);
                }
            )
        }
        ctx.current_deck.countries = countries;
        setVkCtry(vk);
        setOptions(vk);
    }, [countries]);


    // Liste des options (soit Pays soit Langues)
    useEffect(() => {
        const vk = [];
        {
            languages && languages.sort((a, b) => a.language_name_fr > b.language_name_fr ? 1 : -1).map(
                (el, index,) => {
                    let item = {};
                    item["id"] = index;
                    item["label"] = el.language_name_fr;
                    item["language_uid"] = el.language_uid;
                    item["label_en"] = el.language_name_en;
                    vk.push(item);
                }
            )
        }
        ctx.current_deck.languages = languages;
        setVkLang(vk);
    }, [languages]);


    const arr = [];
    {
        regions && regions.sort((a, b) => a.region_alpha2 > b.region_alpha2 ? 1 : -1).map(
            (el, index,) => {
                let item = {};
                item["id"] = index;
                item["label"] = el.region_name_fr;
                item["enabled"] = true;
                item["url"] = `/ct_search_page/${el.region_uid}?r=${el.region_uid}`;
                arr.push(item);
            }
        )
    }
    ctx.current_deck.navlinks = arr;


    const handleChange = (event, value) => {
        setSearchValue(value);
        let idx = 0;
        if (searchMode == "country") {
            for (var i = 0; i < countries.length; i++) {
                if (countries[i].country_name_fr === value) {
                    idx = i;
                    setUid(countries[i].country_iso2);
                    setSelectedCountry(countries[i].country_iso2);
                    setToPage('cy_search_page');
                }
            }
        } else {
            for (var i = 0; i < languages.length; i++) {
                if (languages[i].language_name_fr === value) {
                    idx = i;
                    setUid(languages[i].language_uid);
                    ctx.current_deck.language_deck = []
                    ctx.current_deck.language_deck[0] = languages[i];
                    setToPage('lg_search_page');
                }
            }
        }

    };


    const handleRadioChange = (event) => {
        setSearchMode(event.target.value);
        if (event.target.value === 'country') {
            setOptions(vkCtry);
        } else {
            setOptions(vkLang);
        }
    };

    return (
        <>
            <section id="search" sx={{ display: 'flex', alignItems: 'center', }}>
                <div className="p-4 my-4">
                    <Typography
                        sx={{ display: 'flex', justifyContent: 'center', }}
                        className={`font-articulat_cf font-thin leading-none tracking-tight text-xl md:text-3xl lg:text-5xl text-slate-800 dark:text-white mb-2`}>
                        Cartes &amp; Langues
                    </Typography>
                    {vkCtry && <DrillDownMap8 onCountrySelect={handleCountrySelect} countries={vkCtry} />}
                    
                </div>
                <div>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh', }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', }} className="items-center mt-9">
                                <Autocomplete
                                    className='font-articulat_cf font-thin bg-white dark:bg-zinc-800 w-[200px] md:w-[600px] xl:w-[1000px]'
                                    id="combo-box-demo"
                                    value={selectedCountryName}
                                    options={options.map((option) => option.label)}
                                    renderInput={(params) => <TextField {...params} label="Entrez le nom d'un pays, d'une langue, ou cliquez sur la carte interactive" />}
                                    onChange={handleChange}
                                />
                                {uid ?
                                    (<>
                                        <Link to={`/${toPage}/${uid}`}>
                                            <Button className="ml-4" variant="contained" size="small" sx={{ display: 'flex', }}>
                                                OK
                                            </Button>
                                        </Link>
                                    </>
                                    ) :
                                    (<>
                                        <Button className="ml-4" disabled variant="contained" size="small" sx={{ display: 'flex', }}>
                                            OK
                                        </Button>
                                    </>)
                                }

                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', }} className="p-4">
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={searchMode}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="country" control={<Radio />} label="Pays" />
                                        <FormControlLabel value="language" control={<Radio />} label="Langue" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Box>
                    </Box>
                </div>
            </section>
        </>
    )
}
